<ng-template
	#categorizedListMenuStructureTemplate
	let-dropdownMenuComponent="dropdownMenuComponent"
>
	<sector-selector
		[includeCounts]="false"
		(selectionChange)="relaySelect($event)"
		[optionData]="sectorData"
		[isPrimary]="isPrimary"
		[showFilter]="true"
		[otherField]="otherField"
		[selectableSectors]="selectableSectors"
	></sector-selector>
</ng-template>

<dropdown-menu
	class="sectors"
	label="{{ label }}"
	[menuStructureTemplate]="categorizedListMenuStructureTemplate"
>
</dropdown-menu>
